import React from 'react';
import { Show, SimpleShowLayout, EditButton } from 'react-admin';
import BackButton from '../components/BackButton';
import CardActions from "@material-ui/core/CardActions";
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';
import CustomDefaultShowComponent from '../components/CustomDefaultShowComponent';

const UsersShowActions = ({ basePath, data }) => (
    <CardActions>
        <BackButton style={{ marginRight: "auto" }}></BackButton>
        <EditButton basePath={basePath} record={data} />
    </CardActions>
);

const UserShowGeneral = ({ record }) => {
    const { display_name, disabled } = record;

    return (
        <div className="row">
            <div className="col-12 col-xs-12 col-md-3">
                <div className="row row-cols-2 row-cols-lg-2 g-2 g-lg-2 mb-2">
                    <div className="w-50">
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Name </h6>
                        {display_name ? display_name.length > 0 ? <span className="fw-italic m-0 p-0">{display_name}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                </div>
            </div>
        </div>
    );
};

const UserShowContact = ({ record }) => {
    const { email, phone_number } = record;

    return (
        <div className="row g-2 g-md-2 g-lg-2 w-50">
            <div className="col">
                <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Phone </h6>
                {phone_number ? phone_number.length > 0 ? <span className="fw-italic m-0 p-0">{phone_number}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
            </div>
            <div className="col">
                <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Email </h6>
                {email ? email.length > 0 ? <span className="fw-italic m-0 p-0">{email}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
            </div>
        </div>
    );
};

const UserShowAccess = ({ record }) => {
    const { access, disabled } = record;

    return (
        <div className="row m-0">
            <ul className="col list-group">
                <li class="list-group-item active text-dark fw-bold" style={{ border: 'none', backgroundColor: 'rgb(242, 242, 242)' }} aria-current="true">Access</li>
                <li class="list-group-item fw-light text-secondary">User <span className={(access.user) ? 'text-success' : 'text-danger'}>{(access.user) ? <CheckIcon /> : <ClearIcon />}</span></li>
                <li class="list-group-item fw-light text-secondary">Admin <span className={(access.admin) ? 'text-success' : 'text-danger'}>{(access.admin) ? <CheckIcon /> : <ClearIcon />}</span></li>
            </ul>
            <ul className="col list-group">
                <li class="list-group-item active text-dark fw-bold" style={{ border: 'none', backgroundColor: 'rgb(242, 242, 242)' }} aria-current="true">Status</li>
                <li class="list-group-item fw-light text-secondary">Disabled <span className={(disabled) ? 'text-success' : 'text-danger'}>{(disabled) ? <CircleIcon /> : <CircleIcon />}</span></li>
            </ul>
        </div>
    );
};

const UserShow = (props) => (
    <>
        <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>User</h3>
        <Show title=" " actions={<UsersShowActions />}  {...props}>
            <SimpleShowLayout>
                <UserShowGeneral className="mb-3" record={{ ...props }} />
                <UserShowAccess className="mb-3" record={{ ...props }} />
                <h6 className="font-weight-normal pt-2">{<PermPhoneMsgIcon className="d-inline text-danger" style={{fontSize: '28px'}}/>} Contact</h6>
                <UserShowContact className="mb-3" record={{ ...props }} />
            </SimpleShowLayout>
        </Show>
    </>
);

export default UserShow;